import React from "react";
import styles from "./CartItem.module.css";

const CartProduct = (props) => {
  const { data } = props;
  return (
    <div>
      <div className={`d-flex justify-content-around mb-3 mt-3`}>
        <div className={`d-flex flex-column `}>
          <div className={styles.cartimage}>
            <img src={data.img} alt="" />
          </div>
          <p className={styles.imageTitle}>{data.title}</p>
        </div>
        <div className={`d-flex`}>
          <h6 className={styles.quantity}>個数</h6>
          <div className={styles.minus}>
            <h6>-</h6>
          </div>
          <div className={styles.quantityValue}>
            <h6>1</h6>
          </div>
          <div className={`d-flex flex-column`}>
            <div className={styles.plus}>
              <h6>+</h6>
            </div>
            <div className={styles.delete}>削除</div>
          </div>
        </div>
        <div className={styles.price}>{data.price}</div>
      </div>
      <hr className={styles.hr} />
    </div>
  );
};

export default CartProduct;
